import { useState } from 'react';

export interface UseSheetArgs {
	animationTimeout: number;
	onClose: () => void;
}

export function useSheet({ onClose, animationTimeout }: UseSheetArgs) {
	const [isClosing, setClosing] = useState(false);

	function closeSheet() {
		setClosing(true);
		setTimeout(() => {
			onClose();
		}, animationTimeout);
	}

	return {
		isClosing,
		closeSheet,
	};
}
